import React from 'react'
import { PDFLink } from './styles.js'

const ArticlePDF = ({
  linkToPdf = 'https://assets.ctfassets.net/t0ydv1wnf2mi/59jXRNLEm16IWmw8zFIsPf/c18a3def4a9d6ea0f5b81c6b1e03bc86/Stay-Current-Court-Of-Chancery-Enhances-Standard-Of-Review-For-The-Sale-Of-A-Controlled-Company-To-A-Third-Party.pdf',
  title = 'Click here for a PDF of the full text',
  pdfLinkText = 'Click here for a PDF of the full text',
}) => {
  return (
    <p>
      <PDFLink
        href={linkToPdf}
        target="_blank"
        rel="noreferrer"
        ariaLabel={title}
      >
        {pdfLinkText}
      </PDFLink>
    </p>
  )
}

export default ArticlePDF
